import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { ControlCamera } from '@mui/icons-material';

function isWebrtcPtzDisabled(stream?: VideoStream): boolean {
  if (stream === undefined) return true;
  return !Boolean(stream.features.ptz);
}

function isRportPtzDisabled(stream?: VideoStream): boolean {
  if (stream === undefined) return true;
  return !Boolean(stream.features.ptz);
}

type PTZControlButtonProps = {
  onPtzClick: () => void;
  stream?: VideoStream;
  enabled: boolean;
  type: "RPORT" | "WEBRTC";
}

export const PTZControlButton: React.FC<PTZControlButtonProps> = (props) => {
  const { stream, onPtzClick, enabled, type } = props;

  const [disabled, setDisabled] = React.useState<boolean>(false);

  React.useEffect(() => {
    const disabled = type === "RPORT" ? isRportPtzDisabled(stream) : isWebrtcPtzDisabled(stream);
    setDisabled(disabled);
  }, [stream, type])

  return (
    <Tooltip title={"PTZ"} arrow placement="right">
      <span>
        <IconButton
          data-cy="video-player-ptz-button"
          id="ptz-button-description"
          onClick={onPtzClick}
          disabled={disabled}
          size="small"
        >
          <ControlCamera color={enabled === true ? "primary" : undefined} />
        </IconButton>
      </span>
    </Tooltip>
  )
}